import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { ko } from "date-fns/esm/locale";
import "react-datepicker/dist/react-datepicker.css";

import {
  ChangeSearchingDateFormat,
  SetDateFromDate,
} from "../../../components/common/Common";

//직원 검색
function SalesSearch({ varSearchData, setSearchData, setPageNum }) {
  //항목별 검색변수값 설정
  const [varStartDate, setStartDate] = useState(null);
  const [varEndDate, setEndDate] = useState(null);
  const [varSearchTermMode, setSearchTermMode] = useState(0);
  const [varSearchOption, setSearchOption] = useState("all");
  const [varSearchString, setSearchString] = useState("");

  useEffect(() => {
    console.log("varSearchData", varSearchData);
    setStartDate(
      varSearchData.sdate === null ? null : new Date(varSearchData.sdate)
    );
    setEndDate(
      varSearchData.edate === null ? null : new Date(varSearchData.edate)
    );
    setSearchTermMode(varSearchData.searchTermMode);
    setSearchOption(varSearchData.searchOption);
    setSearchString(varSearchData.searchString);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varSearchData]);

  //검색항목 선택값 저장
  const onSearchOptionHandler = (e) => {
    setSearchOption(e.currentTarget.value);
  };
  //검색문자 저장
  const onSearchStringHandler = (e) => {
    setSearchString(e.currentTarget.value);
  };
  //검색시작
  const onExecuteSearchingHandler = (e) => {
    e.preventDefault();
    setSearchData({
      sdate: ChangeSearchingDateFormat(varStartDate, "-"),
      edate: ChangeSearchingDateFormat(varEndDate, "-"),
      searchTermMode: varSearchTermMode,
      searchOption: varSearchOption,
      searchString: varSearchString,
    });
    setPageNum(1);
  };
  //검색기간 설정값 저장
  const onChangeDateHandler = (ino, date) => {
    if (date === "") date = null;
    if (ino === 0) {
      setStartDate(date);
    } else {
      setEndDate(date);
    }
  };
  //검색정보 초기화
  const onClearSearchHandler = (e) => {
    e.preventDefault();
    setSearchData({
      sdate: null,
      edate: null,
      searchTermMode: 0,
      searchOption: "all",
      searchString: "",
    });
    setPageNum(1);
    setStartDate(null);
    setEndDate(null);
    setSearchTermMode(0);
    setSearchOption("all");
    setSearchString("");
  };

  //검색기간 설정
  const onChangeSearchTermHandler = (e, imode) => {
    const edate = new Date();
    setEndDate(edate);
    if (imode === 1) {
      setStartDate(edate);
    } else if (imode === 2) {
      const sdate = SetDateFromDate("d", -7);
      console.log(sdate);
      setStartDate(sdate);
    } else if (imode === 3) {
      const sdate = SetDateFromDate("m", -1);
      setStartDate(sdate);
    }
  };

  const onChangeTermModeHandler = (e) => {
    const { value } = e.currentTarget;
    setSearchTermMode(Number(value));
    setSearchOption("all");
  };

  //키보드
  const onKeyPressHandler = (e) => {
    if (e.key === "Enter") {
      onExecuteSearchingHandler(e);
    }
  };

  return (
    <div className="main-box">
      <div className="search-area">
        <div className="search-box">
          {/*등록일자*/}
          <div>
            <p className="Title">기간검색</p>
            <input
              type="radio"
              name="searchMode"
              value="0"
              id="mode0"
              checked={varSearchTermMode === 0}
              onChange={onChangeTermModeHandler}
            />
            <label htmlFor="mode0">차량번호별</label>
            <input
              type="radio"
              name="searchMode"
              value="1"
              id="mode1"
              checked={varSearchTermMode === 1}
              onChange={onChangeTermModeHandler}
            />
            <label htmlFor="mode1">배차담당자별</label>
            <div className="datepicker_area">
              <DatePicker
                locale={ko}
                name="sdate"
                className="datepicker"
                dateFormat="yyyy.MM.dd"
                selected={varStartDate}
                selectStart
                onChange={(date) => onChangeDateHandler(0, date)}
              />
              ~
              <DatePicker
                locale={ko}
                name="edate"
                className="datepicker"
                dateFormat="yyyy.MM.dd"
                selected={varEndDate}
                selectEnd
                minDate={varStartDate}
                onChange={(date) => onChangeDateHandler(1, date)}
              />
              <button
                className="search-terms"
                onClick={(e) => onChangeSearchTermHandler(e, 1)}
              >
                오늘
              </button>
              <button
                className="search-terms"
                onClick={(e) => onChangeSearchTermHandler(e, 2)}
              >
                일주일
              </button>
              <button
                className="search-terms"
                onClick={(e) => onChangeSearchTermHandler(e, 3)}
              >
                한달
              </button>
            </div>
          </div>
        </div>

        {/*검색항목*/}
        <div className="search-string">
          <select
            value={varSearchOption}
            style={{ width: "150px" }}
            onChange={(e) => onSearchOptionHandler(e)}
          >
            {varSearchTermMode === 0 ? (
              <>
                <option value={"all"}>전체</option>
                <option value={"dr_carnumb"}>차량번호</option>
              </>
            ) : (
              <>
                <option value={"all"}>전체</option>
                <option value={"mem_name"}>배차담당자명</option>
              </>
            )}
          </select>
          <input
            type="text"
            value={varSearchString}
            onKeyPress={(e) => onKeyPressHandler(e)}
            onChange={(e) => onSearchStringHandler(e)}
            placeholder="검색어를 입력해주세요"
          />
          <button onClick={(e) => onExecuteSearchingHandler(e)} className="btn">
            조회
          </button>
          <button
            onClick={(e) => onClearSearchHandler(e)}
            className="btn black"
          >
            초기화
          </button>
        </div>
      </div>
    </div>
  );
}

export default SalesSearch;
